var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PlatformConnectionsListView"},[_c('ShPageHeader',{attrs:{"title":"Lista połączeń","description":"Lista połaczeń wszystkich projektów IVR","breadcrumb-items":[
                  { label: 'zarządzanie' },
                  { label: 'lista połączeń', path: '/connections-list' }
                ]}}),_c('ShPageLayout',[_c('ConnectionsList',{attrs:{"project-list":_vm.projectList}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }